<div class="custom-dialog" [formGroup]="addQuestionForm">
    <div class="dialog-content">
      <div class="dialog-header">
        <div>
          <label class="advance">Add New Question</label>
        </div>
      </div>
      <div class="dialog-body">
        <form>
          <div class="Col">
            <!-- Category Dropdown -->
            <div class="rows">
              <div class="col-3">Category</div>
              <div class="col-9">
                <mat-form-field appearance="fill" class="full-width" subscriptSizing="dynamic" floatLabel="never" [ngClass]="{'is-invalid': addQuestionForm.get('category')?.invalid && addQuestionForm.get('category')?.touched}">
                  <mat-select
                    placeholder="Select a Category"
                    formControlName="category"
                  >
                    <mat-option *ngFor="let category of categories" [value]="category.id">
                      {{ category.description }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                  <mat-error style="font-size: 13px;"*ngIf="addQuestionForm.get('category')?.invalid && addQuestionForm.get('category')?.touched">
                    Category is required.
                  </mat-error>
              </div>
            </div>
            
            <div class="rows">
              <div class="col-3">Sub-Category</div>
              <div class="col-9">
                <mat-form-field appearance="fill" class="full-width" subscriptSizing="dynamic" floatLabel="never" [ngClass]="{'is-invalid': addQuestionForm.get('subCategory')?.invalid && addQuestionForm.get('subCategory')?.touched}">
                  <mat-select
                    placeholder="Select a Sub-Category"
                    formControlName="subCategory"
                  >
                    <mat-option *ngFor="let subCategory of subCategories" [value]="subCategory.id">
                      {{ subCategory.description }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                <mat-error style="font-size: 13px;"*ngIf="addQuestionForm.get('subCategory')?.invalid && addQuestionForm.get('subCategory')?.touched">
                    Sub-Category is required.
                  </mat-error>
              </div>
            </div>          
            <!-- Question Field -->
            <div class="rows">
              <div class="col-3">Question</div>
              <div class="col-9">
                <textarea
                  class="form-control"
                  rows="3"
                  placeholder="Start typing question"
                  [ngClass]="{'is-invalid': addQuestionForm.get('question')?.invalid && addQuestionForm.get('question')?.touched}"
                  formControlName="question"
                ></textarea>
                <div class="invalid-feedback" *ngIf="addQuestionForm.get('question')?.invalid && addQuestionForm.get('question')?.touched">
                  Question is required.
                </div>
              </div>
            </div>
  
            <!-- Weightage Field -->
            <div class="rows">
              <div class="col-3">Weightage</div>
              <div class="col-9">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Weightage"
                  formControlName="weightage"
                />
              </div>
            </div>
          </div>
        </form>
      </div>
  
      <div class="dialog-footer">
        <button type="button" class="btn btn-primary" (click)="saveDialog()">Submit</button>
        <button type="button" class="btn btn-secondary" (click)="closeDialog()">Close</button>
      </div>
    </div>
  </div>